import { render } from "./tooltipGalleryCarousel.vue?vue&type=template&id=610f4332&scoped=true"
import script from "./tooltipGalleryCarousel.vue?vue&type=script&lang=js"
export * from "./tooltipGalleryCarousel.vue?vue&type=script&lang=js"

import "./tooltipGalleryCarousel.vue?vue&type=style&index=0&id=610f4332&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610f4332"]])

export default __exports__